import { isValidReferralCode } from '@/lib/utils/signup-referral-capture';

import type { SendInviteBlockReason } from './types';

export const CREDITS_PER_REFERRAL = 100;
export const REFERRAL_PLAN_REWARDS = [
  { plan: 'Plus', backendPlan: 'Lite', credits: 1000 },
  { plan: 'Pro', backendPlan: 'Standard', credits: 2500 },
  { plan: 'Max', backendPlan: 'Pro', credits: 5000 },
  { plan: 'Business', backendPlan: 'Business', credits: 10000 }
] as const;

export const DEFAULT_SUBSCRIBED_REFERRAL_CREDITS = REFERRAL_PLAN_REWARDS[0].credits;
export const MAX_SUBSCRIBED_REFERRAL_CREDITS = Math.max(
  ...REFERRAL_PLAN_REWARDS.map((reward) => reward.credits)
);
export const MAX_CREDITS_PER_REFERRAL =
  CREDITS_PER_REFERRAL + MAX_SUBSCRIBED_REFERRAL_CREDITS;

export const buildSignupInviteUrl = (code: string): string => {
  if (!code) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/signup?ref=${code}`;
};

// Only codes backend redeem will accept (exactly 12 Crockford chars).
export const validReferralCodeOrNull = (
  code: string | null | undefined
): string | null => (isValidReferralCode(code) ? code : null);

export const appendReferralCodeToUrl = (
  url: string,
  code: string | null | undefined
): string => {
  const validCode = validReferralCodeOrNull(code);
  if (!url || !validCode) return url;
  return `${url}${url.includes('?') ? '&' : '?'}ref=${validCode}`;
};

export const blockReasonMessage = (reason: SendInviteBlockReason | null): string => {
  switch (reason) {
    case 'invalid_email':
      return 'That email address looks invalid.';
    case 'self_invite':
      return "You can't invite yourself.";
    case 'disposable_email':
      return "That email provider isn't supported.";
    case 'no_referral_code':
      return "Couldn't load your invite code. Try refreshing.";
    case 'email_provider_error':
      return 'Email service is temporarily down. Try again.';
    default:
      return 'Could not send invitation. Try again.';
  }
};
